import * as React from 'react';
import { useGroundingCommandBarTabList_unstable } from './useGroundingCommandBarTabList';
import { renderGroundingCommandBarTabList_unstable } from './renderGroundingCommandBarTabList';
import { useGroundingCommandBarTabListStyles_unstable } from './useGroundingCommandBarTabListStyles.styles';
import type { GroundingCommandBarTabListProps } from './GroundingCommandBarTabList.types';
import type { ForwardRefComponent} from '@fluentui/react-components';
import { useTabListContextValues_unstable } from '@fluentui/react-components';

// GroundingCommandBarTabList component - TODO: add more docs
export const GroundingCommandBarTabList: ForwardRefComponent<GroundingCommandBarTabListProps> = React.forwardRef(
  (props, ref) => {
    const state = useGroundingCommandBarTabList_unstable(props, ref);

    useGroundingCommandBarTabListStyles_unstable(state);
    const contextValues = useTabListContextValues_unstable(state);
    return renderGroundingCommandBarTabList_unstable(state, contextValues);
  },
);

GroundingCommandBarTabList.displayName = 'GroundingCommandBarTabList';
